var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.237,
    height: 20.237,
    viewBox: "0 0 20.237 20.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus-icon",
    d: "M-1368.882-965.763a1,1,0,0,1-1-1v-8.118H-1378a1,1,0,0,1-1-1,1,1,0,0,1,1-1h8.118V-985a1,1,0,0,1,1-1,1,1,0,0,1,1,1v8.119h8.119a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-8.119v8.118A1,1,0,0,1-1368.882-965.763Z",
    transform: "translate(1379 986)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.bf09f1884ce8e041a39f9dbff1a613d0.svg";
export { ForwardRef as ReactComponent };